import React from "react";
import * as MUIStyled from "../../../MUIStyled";
import {
  ProgressBarMainWrapper,
  ProgressInnerBox,
  StyledProgressOuterBox,
} from "../../../CompanyForm.styled";
const ProgressBarStepper = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <ProgressBarMainWrapper>
      <MUIStyled.BorderLinearProgress
        variant="determinate"
        value={progress}
        sx={{
          width: {
            xs: "80%",
            sm: "65%",
            md: "50%",
            lg: "50%",
            xl: "30%",
          },
        }}
      />
      <StyledProgressOuterBox>
        <ProgressInnerBox>{`${currentStep}/${totalSteps}`}</ProgressInnerBox>
      </StyledProgressOuterBox>
    </ProgressBarMainWrapper>
  );
};

export default ProgressBarStepper;
